(function () {
  'use strict';
  if (window.__mipPlpProgressiveLoad) return;
  window.__mipPlpProgressiveLoad = true;

  var autoLoads = 0;
  var manualBatch = null;
  var scheduled = false;
  var loadingByUs = false;
  var requestLoading = false;
  var autoPaused = false;
  var rootSelector = '.collection-default[data-mip-auto-load-limit]';

  function root() { return document.querySelector(rootSelector); }
  function listing() { return document.querySelector('#CollectionProductGrid .productListing'); }
  function link() { return document.querySelector('#CollectionProductGrid [data-infinite-scrolling]'); }
  function ready() { return document.documentElement.hasAttribute('data-mip-load-more-ready'); }
  function limit() {
    var node = root();
    var value = node ? parseInt(node.dataset.mipAutoLoadLimit || '5', 10) : 5;
    return Number.isFinite(value) ? Math.max(0, value) : 5;
  }

  function soldOutLastEnabled() {
    var node = root();
    return !!node && node.dataset.mipSoldoutLast !== 'false';
  }

  function updateButtonState() {
    var node = link();
    var canAuto = ready() && !!root() && !!node && !autoPaused && autoLoads < limit();
    document.documentElement.classList.toggle('mip-plp-auto-loading-enabled', canAuto);
    document.documentElement.classList.toggle('mip-plp-is-loading', requestLoading || !!manualBatch);
    if (node) node.setAttribute('data-mip-auto-remaining', String(Math.max(0, limit() - autoLoads)));
    var pagination = node && node.closest('.pagination-page-infinite');
    if (pagination) {
      var status = pagination.querySelector('.mip-plp-loading-status');
      if (!status) {
        status = document.createElement('span');
        status.className = 'mip-plp-loading-status';
        status.setAttribute('role', 'status');
        status.setAttribute('aria-live', 'polite');
        pagination.appendChild(status);
      }
      status.textContent = (requestLoading || manualBatch) ? (node.getAttribute('data-loading-more') || 'Loading…') : (node.hasAttribute('data-mip-load-error') ? 'Unable to load more products. Please try again.' : '');
    }
  }

  function availableCount() {
    var grid = listing();
    if (!grid) return 0;
    return Array.from(grid.children).filter(function (node) {
      return node.classList && node.classList.contains('product') && node.dataset.productAvailable !== 'false';
    }).length;
  }

  function needsInitialPrefill() {
    return soldOutLastEnabled() && availableCount() > 0 && availableCount() < 4 && autoLoads < limit();
  }

  function nearPagination() {
    var node = link();
    if (!node || node.classList.contains('is-loading')) return false;
    var rect = node.getBoundingClientRect();
    var viewport = window.innerHeight || document.documentElement.clientHeight;
    return rect.top <= viewport + Math.max(900, viewport * 1.5);
  }

  // Anchor clicks can navigate if a click listener prevents the delegated
  // loader from receiving them. Request appends without activating a link.
  function requestPage(node) {
    node.removeAttribute('data-mip-load-error');
    var detail = { link: node, handled: false };
    document.dispatchEvent(new CustomEvent('mip:load-more:request', { detail: detail }));
    if (!detail.handled) {
      document.dispatchEvent(new CustomEvent('mip:load-more:error', { detail: { reason: 'loader-unavailable' } }));
    }
  }

  function maybeAutoLoad() {
    scheduled = false;
    var node = link();
    if (manualBatch || loadingByUs || requestLoading || (node && node.classList.contains('is-loading'))) { updateButtonState(); return; }
    if (!ready() || !root() || !node || autoPaused || autoLoads >= limit()) { updateButtonState(); return; }
    if (!needsInitialPrefill() && !nearPagination()) { updateButtonState(); return; }
    loadingByUs = true;
    updateButtonState();
    requestPage(node);
    if (!node.classList.contains('is-loading')) {
      loadingByUs = false;
      autoPaused = true;
      updateButtonState();
    }
  }

  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(maybeAutoLoad);
  }

  function resetForNewQuery() {
    manualBatch = null;
    autoLoads = 0;
    loadingByUs = false;
    requestLoading = false;
    autoPaused = false;
    updateButtonState();
    schedule();
  }

  function init() {
    updateButtonState();
    schedule();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();

  window.addEventListener('scroll', schedule, { passive: true });
  window.addEventListener('resize', schedule, { passive: true });
  window.addEventListener('pageshow', schedule, { passive: true });
  document.addEventListener('mip:load-more:ready', schedule);

  document.addEventListener('click', function (event) {
    var node = event.target.closest && event.target.closest('#CollectionProductGrid [data-infinite-scrolling]');
    if (!node || !root() || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || (event.button != null && event.button !== 0)) return;
    // Claim normal clicks even before the deferred loader has started.
    event.preventDefault();
    event.stopImmediatePropagation();
    if (manualBatch || requestLoading || node.classList.contains('is-loading')) return;
    manualBatch = { pages: 0, products: 0, listing: listing() };
    autoPaused = true;
    requestPage(node);
  }, true);

  document.addEventListener('mip:load-more:start', function () {
    requestLoading = true;
    updateButtonState();
  });

  document.addEventListener('mip:load-more:complete', function (event) {
    if (loadingByUs) autoLoads += 1;
    loadingByUs = false;
    requestLoading = false;
    if (manualBatch) {
      var batch = manualBatch;
      batch.pages += 1;
      batch.products += Number(event.detail && event.detail.appended) || 0;
      if (batch.listing === listing() && link() && (batch.pages < 5 || batch.products < 100)) {
        updateButtonState();
        requestAnimationFrame(function () {
          if (manualBatch !== batch || batch.listing !== listing()) return;
          var next = link();
          if (!next) { manualBatch = null; updateButtonState(); return; }
          requestPage(next);
        });
        return;
      }
      manualBatch = null;
    }
    updateButtonState();
    schedule();
  });

  document.addEventListener('mip:collection:updated', resetForNewQuery);
  document.addEventListener('mip:load-more:error', function (event) {
    if (link()) link().setAttribute('data-mip-load-error', event.detail ? (event.detail.reason + ':' + (event.detail.status || '')) : 'request-failed');
    manualBatch = null;
    loadingByUs = false;
    requestLoading = false;
    autoPaused = true;
    updateButtonState();
  });
})();
